import { render, staticRenderFns } from "./admin_roster.vue?vue&type=template&id=4ad70f2a&scoped=true&"
import script from "./admin_roster.vue?vue&type=script&lang=ts&"
export * from "./admin_roster.vue?vue&type=script&lang=ts&"
import style0 from "./admin_roster.vue?vue&type=style&index=0&id=4ad70f2a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ad70f2a",
  null
  
)

export default component.exports